import React from 'react'

/*
 * The hairline the sheet puts between two groups of rows. It runs the full
 * width of the panel - past the panel's own padding - which is why it carries a
 * negative margin rather than sitting inside it.
 */
const DropdownMenuSeparator = () => <div className="dropdown-menu-separator"/>

export default DropdownMenuSeparator



// WEBPACK FOOTER //
// ./src/components-new/ui/DropdownMenu/DropdownMenuSeparator.jsx